"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shallow = shallow;
Object.defineProperty(exports, "Component", {
  enumerable: true,
  get: function get() {
    return _Component["default"];
  }
});
Object.defineProperty(exports, "DOMComponent", {
  enumerable: true,
  get: function get() {
    return _DOMComponent["default"];
  }
});
Object.defineProperty(exports, "Document", {
  enumerable: true,
  get: function get() {
    return _Document["default"];
  }
});
Object.defineProperty(exports, "DocFlux", {
  enumerable: true,
  get: function get() {
    return _DocFlux["default"];
  }
});
Object.defineProperty(exports, "DocFluxTest", {
  enumerable: true,
  get: function get() {
    return _DocFluxTest["default"];
  }
});
exports["default"] = void 0;

var _Component = _interopRequireDefault(require("./Component"));

var _DOMComponent = _interopRequireDefault(require("./DOMComponent"));

var _Document = _interopRequireDefault(require("./Document"));

var _DocFlux = _interopRequireDefault(require("./DocFlux"));

var _DocFluxTest = _interopRequireDefault(require("./DocFluxTest"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function shallow(component) {
  return _DocFluxTest["default"].shallow(component);
}

var _default = _DocFlux["default"];
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@harvest-profit/doc-flux/dist/index.js
// module id = 0
// module chunks = 0